"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ai_1 = require("react-icons/ai");
const react_router_dom_1 = require("react-router-dom");
const SidebarAdmin_1 = require("./SidebarAdmin");
const react_2 = require("react");
const SidebarMobile = () => {
    const cancelRef = (0, react_2.useRef)(null);
    const handleClick = () => {
        var _a;
        (_a = cancelRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "container-nav" },
            react_1.default.createElement("input", { type: "checkbox", id: "check" }),
            react_1.default.createElement("label", { htmlFor: "check" },
                react_1.default.createElement(ai_1.AiOutlineMenuUnfold, null),
                react_1.default.createElement("i", { className: "fas fa-times", id: "cancel", ref: cancelRef })),
            react_1.default.createElement("div", { className: "sidebar", id: "scrollbar-nav-mobile" },
                react_1.default.createElement("div", { className: "content-nav-mobile" },
                    react_1.default.createElement("div", { className: "container-user-connect-info pb-4 d-flex justify-content-center" },
                        react_1.default.createElement("div", { className: "container-info-user-connect-navmenu" })),
                    react_1.default.createElement("div", { className: "content-nav-mobile-scroll" },
                        react_1.default.createElement("ul", { className: "nav nav-items-custom flex-column" }, SidebarAdmin_1.menuItem === null || SidebarAdmin_1.menuItem === void 0 ? void 0 : SidebarAdmin_1.menuItem.map((menu, i) => (react_1.default.createElement("li", { className: "nav-item nav-item-vertical-custom", key: i },
                            react_1.default.createElement(react_router_dom_1.NavLink, { className: "nav-link nav-link-vertival-custom-admin", to: menu === null || menu === void 0 ? void 0 : menu.path, onClick: handleClick }, menu === null || menu === void 0 ? void 0 :
                                menu.icon,
                                react_1.default.createElement("span", { className: "item-nav-menu drop-header" }, menu === null || menu === void 0 ? void 0 : menu.label))))))))))));
};
exports.default = SidebarMobile;
